import React from 'react'
import { Dropdown } from 'react-bootstrap'
import useCurrentUser from '../../../hooks/use-current-user'
import BusyModal from '../../modals/busy'
import moment from 'moment'
import useCourseDelete from './use-course-delete'

const ExperiencesDuplicateMenu = ({
    experience = {},
}) => {
    const { isAdmin, isFacilitator, currentUser } = useCurrentUser()

    const { deleteCourse, isDeletingCourse } = useCourseDelete({ courseId: experience.id })

    if (isDeletingCourse) {
        return (
            <BusyModal title='Removing experience...' />
        )
    }

    const canRemoveByDate = moment().isSameOrBefore(experience.date, 'day')
    const canRemoveByRole =  isAdmin || (isFacilitator && experience.facilitatorId === currentUser.id )
    const canRemove = canRemoveByDate && canRemoveByRole

    return (
        <Dropdown.Item
            onClick={() => deleteCourse()}
            disabled={!canRemove || isDeletingCourse}
        >
            Remove
        </Dropdown.Item>
    )
}

export default ExperiencesDuplicateMenu